module.exports = __webpack_public_path__ + "static/img/pro3_tab2.330fe62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro3_tab2.jpg
// module id = KMbQ
// module chunks = 171